module.exports = __webpack_public_path__ + "img/user-dummy-img2.605382f3.png";